module.exports = __webpack_public_path__ + "1548edca60b9a861c6e3bee4032c9578.png";